import './App.css';
import Home from './Component/Home/Home';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}
// https://www.youtube.com/watch?v=G_1_VEwXkQk&list=PLISG6SSQ9nqyuuTjr2cDApJlY9-K3jrn1&index=2

export default App;
